import { Util } from "../util.js";
import { SimilarCombosTile } from "./similar_combos_tile.js";
import { ModalTracking } from "./modal_tracking.js";

const util = new Util();

export class SimilarCombosModal {
	constructor(dom, comboType) {
		this._comboType = comboType;
		this.modalTracking = new ModalTracking();
		this._tiles = [];
		this._promoType = util.readFromDataAttribute(dom, "promo_type");

		const tilesContainers = Array.from(dom.getElementsByClassName("similar-combo__tiles"));

		if (tilesContainers && tilesContainers.length > 0) {
			tilesContainers.forEach((tileDom, index) => {
				const link = tileDom.querySelector("oc-link-v2, a");
				if (link) {
					const tile = new SimilarCombosTile(link);
					this._tiles.push(tile);
					this.attachClickEventListenersToTiles(tileDom, tile, index);
				}
			});
		}
	}

	attachClickEventListenersToTiles(tileDom, tile, index) {
		tileDom.addEventListener("click", () =>
			this.modalTracking.sendSimilarComboClickTrackingEvent(
				this.getSimilarityTrackingInfo(tile, index),
				this._comboType
			)
		);
	}

	getSimilarityTrackingInfo(item, index) {
		return {
			clickedCombo: {
				id: item.getComboId(),
				similarityScore: item.getSimilarityScore(),
				position: index + 1,
				comboSource: item.getComboSource()
			},
			numberOfCombos: this._tiles.length
		};
	}

	getTiles() {
		return this._tiles;
	}

	getPromoType() {
		return this._promoType;
	}
}
